import { Location } from "@angular/common";
import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";

import { SvgIconComponent } from "@hermes/aphrodite-svg";
import { Context, LOCALE, WINDOW } from "@hermes/core-app-core";
import { AnalyticsService } from "@hermes/hermes-web-fragments-analytics";

import { isWeChatAgent } from "@hermes/utils-generic-helpers";
import { RouterService } from "@hermes/utils-generic-services-router";

import {
    CHECKOUT_ACCOUNT_BACK_BUTTON,
    CHECKOUT_BACK_BUTTON,
} from "./back-button-checkout.constants";
import { BackButtonCheckoutAnalyticsEvent } from "./back-button-checkout.event";

@Component({
    selector: "h-back-button-checkout",
    imports: [SvgIconComponent],
    templateUrl: "./back-button-checkout.component.html",
    styleUrls: ["./back-button-checkout.component.scss"],
})
export class BackButtonCheckoutComponent implements OnInit, OnDestroy {
    private location = inject(Location);
    private analyticsService = inject(AnalyticsService);
    private router = inject(Router);
    private routerService = inject(RouterService);
    private context = inject(Context);
    private activatedRoute = inject(ActivatedRoute);
    private window = inject<Window>(WINDOW);
    private locale = inject(LOCALE);

    private subscription: Subscription = new Subscription();
    private step!: string;

    public ngOnInit(): void {
        this.subscription.add(
            this.activatedRoute.queryParams.subscribe((data) => {
                this.step = data["step"];
            }),
        );
    }
    public goBackLink(): void {
        const eventType = this.window.location.href.includes("login")
            ? CHECKOUT_ACCOUNT_BACK_BUTTON
            : CHECKOUT_BACK_BUTTON;
        this.analyticsService.sendData(
            new BackButtonCheckoutAnalyticsEvent({
                eventType,
            }),
        );
        // weChat app sometimes as realy quirky navigation, so we have to explictly tell it where to navigate on back to prevent getting stuck in navigation loops
        if (
            this.context.isInBrowserMode() &&
            isWeChatAgent(this.window.navigator.userAgent)
        ) {
            if (this.location.path().includes("/checkout/")) {
                this.router.navigate(["cart", ""]);
            }
            if (this.location.path().includes("/cart")) {
                this.window.location.href = `${this.locale.urlPrefix}/`;
            }
        }
        if (this.location.path().includes("/login") && !this.step) {
            this.routerService.spaRedirect("/cart/");
        }
        this.location.back();
    }
    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
